import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    containerBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '960px',
      padding: 0,
      margin: '0 auto',

      [theme.breakpoints.up('sm')]: {
        // padding: 20,
        height: 'auto',
        margin: '24px auto',
      },
    },
  }),
);

export default useStyles;
